module.exports = __webpack_public_path__ + "static/img/赛事介绍_47.0127681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/赛事介绍_47.png
// module id = o2iV
// module chunks = 6